import { useDroppable } from '@dnd-kit/core';
import type { ReactNode } from 'react';

interface DroppableDayProps {
  id: string;
  dateString: string;
  children: ReactNode;
  disabled?: boolean;
}

export function DroppableDay({ id, dateString, children, disabled }: DroppableDayProps) {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: { dateString },
    disabled,
  });

  return (
    <div
      ref={setNodeRef}
      className="h-full"
      style={{
        outline: isOver ? '2px solid #10b981' : undefined,
        backgroundColor: isOver ? 'rgba(16, 185, 129, 0.1)' : undefined,
      }}
    >
      {children}
    </div>
  );
}
